import React, { Suspense, useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import AppWrapper from "@jumbo/components/AppWrapper";
import { Redirect, Route, Switch, withRouter } from "react-router";
import PageLoader from "@jumbo/components/PageComponents/PageLoader";
import LayoutContext from "@coremat/CmtLayouts/LayoutContext";
import { fetchError, fetchLoading, fetchStart, fetchSuccess } from "redux/actions";
import { Request, RequestConfig } from "../request";
import { Principal } from "../auth";
import { connect, useDispatch } from "react-redux";
import { setSideBar } from "../slices/app";
import { type } from "../utils/common";
import { get_request_config, unKeepCache } from "./root";
import Router from "../electron/renderer/router";
import {
  getScrollLeft,
  getScrollTop,
  scrollLeft,
  scrollTop
} from "@coremat/CmtLayouts/Vertical/Content";
import Loadable from "react-loadable";
import lazy from "./lazy";
import { LAYOUT_TYPES, SIDEBAR_WIDTH, THEME_TYPES } from "@jumbo/constants/ThemeOptions";
import AppContext from "@jumbo/components/contextProvider/AppContextProvider/AppContext";
import ContentLoader from "@jumbo/components/ContentLoader";
import Button from "@codeArt/components/button";
import { filter as filterExtension,activate } from "@codeArt/extension";
import { process as processMenu } from "@codeArt/extension/contributes/sidebar.menu/index";
import { requestUrl } from "@codeArt/utils/url";
import { AsyncComponent, memo } from "@codeArt/components/common";
import { JSON } from "@codeArt/utils/object";
import { THEME_COLORS } from "@jumbo/constants/CustomizerOptions";
import SidebarThemeContext from "@coremat/CmtLayouts/SidebarThemeContext/SidebarThemeContext";
import { getTheme } from "./theme";
let _ = require("lodash");
let base64 = require("base-64");

// export const {BAProvider} = (function(){

//   let _bindActivateds = {};
//   let BAProvider = {
//     getOrCreate: (keepId) => {
//       if (!keepId) return;
//       let l = _bindActivateds[keepId];
//       if (!l) {
//         l = _bindActivateds[keepId] = [];
//       }
//       return l;
//     },
//     get: (keepId) => {
//       if (!keepId) return;
//       return _bindActivateds[keepId];
//     },
//     remove: (keepId) => {
//       delete _bindActivateds[keepId];
//     },
//     clear: () => {
//       _bindActivateds = {};
//     }
//   }

//   return {BAProvider};

// })();

export const { Scroller } = (function () {
  let _scrollRecords = {};
  let _scrollLoadTimes = 0;

  const Scroller = {
    save: keepId => {
      if (!keepId) return;
      _scrollRecords[keepId] = Scroller.get();
    },
    load: keepId => {
      if (!keepId) return;
      let data = _scrollRecords[keepId];
      if (!data) return false;

      // let host = document.getElementById(Scroller.host);
      // if (host.scrollHeight === host.offsetHeight) return; //如果滚动条高度等于滚动条所在宿主的高度，那么滚动条是没有可移动空间的，也就是没有滚动条
      Scroller.set(data);
      _scrollLoadTimes++;

      //效验是否改变
      let pos = Scroller.get();
      if (
        (pos.top === data.top && pos.left === data.left) || //已设置成功
        (pos.top > 0 || pos.left > 0) || //用户在滚动条加载期间动了屏幕
        _scrollLoadTimes >= 10
      ) {
        //超过尝试加载的最大次数
        //满足了3个条件之一，那么删除数据，不再加载
        delete _scrollRecords[keepId];
        _scrollLoadTimes = 0;
      } else {
        setTimeout(() => {
          Scroller.load(keepId);
        }, 100);
      }
    },
    remove: keepId => {
      delete _scrollRecords[keepId];
    },
    clear: () => {
      _scrollRecords = {};
    },
    get: () => {
      return { top: getScrollTop(), left: getScrollLeft() };
      // var host = document.getElementById(Scroller.host);
      // return { top: host.scrollTop, left: host.scrollLeft };
    },
    set: ({ top, left }) => {
      scrollTop(top);
      scrollLeft(left);
    },
    dispose: () => {
      _scrollRecords = {};
      _scrollLoadTimes = 0;
    }
  };

  return { Scroller };
})();

const processSidebar = (appName,sidebar,arg)=>{
  const result = processMenu(appName,sidebar,arg); //返回的是{sidebar,routes}
  return result;
}

class _App extends AsyncComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      routes:[...props.routes]
    };
    _App.current = this; //同一时间，只有一个App实例
    this.history = new History();
    this.keepIds = [];
    this.name = props.name || "extra";
  }

  dispatch() {
    return this.props.dispatch;
  }

  data() {
    return { ...this.props.data };
  }

  getRoutes = ()=>{
    return this.state.routes;
  }

  renderDefaultRedirect() {
    //当没有具体路径时，默认定位哪个页面
    let { match,matchUrl } = this.props;  //外界可以手工修正match.url为matchUrl
    let routes = this.getRoutes();
    if (!routes) return;
    let route = _.find(routes, t => t.default) || routes[0];
    if (!route) return;
    const path = this.findSidebarPath(route);
    return path ? <Redirect exact from={matchUrl||match.url} to={path} /> : null;
  }

  //找到route对应的路径，注意，带参数的，要在sidebar的配置中找路径
  findSidebarPath(route){
    if(!route.path) return;
    if(route.path.endsWith("/:params")){
      const sidebar = this.props.getSidebar();
      const target = route.path.substr(0,route.path.lastIndexOf("/"));
      let menus = sidebar.menus || [];
      const f = (ms)=>{
        for(let i=0;i<ms.length;i++){
          let {link,children} = ms[i];
          if(link){
            if(link.substr(0,route.path.lastIndexOf("/")) === target) return link;
          }

          if(children){
            let r = f(children);
            if(r) return r;
          }
        }
      }
      return f(menus);
    }
    return route.path;
  }

  renderRoutes() {
    let routes = this.getRoutes();
    if (!routes) return;
    return routes.map(({ path, component }, index) => {
      return <Route key={`route-${index}`} path={path} component={component} />;
    });
  }

  render404() {
    let { component404: c } = this.props;
    c = c || lazy(() => import("routes/ExtraPages/404/index"));
    return <Route component={c} />;
  }

  initialize() {
    this.setState({ loading: true });

    let { request,load } = this.props;
    setRequestConfig(request || get_request_config() || {});

    if(!load) load = (success)=> success();

      this.initExtension(()=>{
        
        this.auth(() => {

          load((data)=>{
          this.getSidebar(data,(sidebar) => {
    
            let { setSideBar, getLayout } = this.props;
            if (sidebar) setSideBar(sidebar); //赋值给redux
    
            let layout = getLayout ? getLayout(data) : {};
            this.setLayout(layout);
            this.originalLayout = layout;//记录原始布局
    
            this.activeAppExtension("onProApp",()=>{  //布局初始完后，激活onProApp的插件
              let { init } = this.props;
    
              const succcess = () => {
                this.setState({ loading: false });
              };
      
              if (init) init(succcess);
              else succcess();
            })
          });
        });
      }); 

    });
  }

  getMatchUrl=()=>{
    let { match,getMatchUrl } = this.props;
    if(getMatchUrl) return getMatchUrl();
    return requestUrl(match);
  }

  getSidebar(data,cb) {
    let { name,getSidebar } = this.props;
    let sidebar = getSidebar ? { ...getSidebar(data) } : null;
    //插件处理
    const result = processSidebar(name,sidebar,{matchUrl:this.getMatchUrl(),routes:this.getRoutes()});
    sidebar = result.sidebar;
    this.setState({routes:result.routes});
    if (sidebar) {
      //验证权限
      filterMenus(sidebar.menus).then((menus) => {
        sidebar.menus = menus;
        cb(sidebar);
      });
    }
    else
      cb(sidebar);
  }

  setLayout(layout) {
    this.setState({ layout: { ...this.getLayout(), ...layout } }); //使用这种办法，让每次布局的改变是增量式（修改了的则改，没有修改的则保留原样）
  }

  getLayout() {
    return this.state.layout;
  }

  resetLayout() {  //重置布局到初始状态
    this.setState({ layout: this.originalLayout });
  }

  //由于一些原因，可以在短时间内对全局布局设置好几遍，这个方法就用来处理这个场景
  applyLayout = _.debounce((type,arg) => {  //type:set或 reset
    if(type==="set") {
      this.setLayout(arg);
      return;
    }
    if(type==="reset") {
      this.resetLayout();
      return;
    }
  }, 50);
  
  //#region 扩展程序

  initExtension(cb){
    let {extension} = this.props;
    const {getPredicate} = extension || {};
    if(getPredicate) {
      getPredicate().then((predicate)=>{  //考虑到过滤插件可能需要与服务端交互，所以是异步获取过滤方法
        filterExtension(predicate);
        this.activeAppExtension("onPreApp",cb);
      });
      return;
    }

    filterExtension((p)=> false); //当没有设置getPredicate过滤，表示没有启用任何插件
    this.activeAppExtension("onPreApp",cb);
  }

  activeAppExtension(eventName,cb){
    let my = this;
    let {name} = this;
    const detailEventName=`${eventName}:${name}`; //绑定程序名称,例如：onPreApp:main
    activate(detailEventName).then((deactivate)=>{
      my[`${eventName}_${name}_deactivate`] = deactivate;
      cb();
    });
  }

  deactivateAppExtension(eventName,cb){
    let my = this;
    let {name} = this;
    let deactivateEventName = `${eventName}_${name}_deactivate`;
    if(my[deactivateEventName]) {
      my[deactivateEventName]().then(()=>{
        my[deactivateEventName] = null;
        cb();
      });
      return;
    }
    cb();
  }

  disposeExtension(cb){
    this.deactivateAppExtension("onProApp",()=>{ //先销毁pro事件
      this.deactivateAppExtension("onPreApp",()=>{
        filterExtension(false); //取消过滤
        cb();
      });  //再销毁pre事件
    });
  }


  //#endregion

  auth(cb) {
    let { dispatch, auth } = this.props;
    if (auth === false) {
      cb();
      return;
    }
    let principal = new Principal({ dispatch });
    auth = auth || {}; //默认只需要登录
    Request(
      {
        url: "/enter",
        data: { platform: this.name, ...auth.data },
        success: r => {

          principal.store(); //将storage里的数据同步到store里，防止刷新页面，store里的用户数据丢失
          let auther = Principal.setAuther(r);

          auther.verify({ ...auth }, dispatch).then(({ allow, message }) => {
            if (allow) cb();
            else {
              signOut({ principal });
            }
          }).catch((e) => {
            throw e;
            // 实际使用发现，有时候是非验证出错，需要显示出异常信息
            // signOut({ principal });
          });
        },
        error: (msg, dispatch) => {
          this.setState({ error: msg });
        }
      },
      dispatch
    );
  }

  dispose() {
    this.disposeExtension(()=>{
      const {dispose,dispatch} = this.props;
      if(dispose) {
        dispatch(fetchLoading(true));
        dispose(()=> dispatch(fetchLoading(false)));
      }
  
      Scroller.dispose();
      this.clearKeep();
    });
  }

  go(name, params, onBack) {
    if (!params) {
      this.props.history.push({
        pathname: name
      });
    } else {
      let code = App.getParamsCode(params);
      this.props.history.push({
        pathname: `${name}/${code}`
      });
    }
    this.history.push({ name, params, onBack });
  }

  replace(name, params) {
    if (!params) {
      this.props.history.replace({
        pathname: name
      });
    } else {
      let code = App.getParamsCode(params);
      this.props.history.replace({
        pathname: `${name}/${code}`
      });
    }
  }

  back() {
    this.props.history.goBack();
    let arg = this.history.pop();
    if (arg && arg.onBack) arg.onBack();
  }

  registerKeep(keepId) {
    let keepIds = this.keepIds;
    if (keepIds.indexOf(keepId) === -1) keepIds.push(keepId);
  }

  clearKeep(v, exclude) {
    if (exclude && type(exclude) !== "array") exclude = [exclude];
    if (v === true) {
      //移除除了指定的exclude以外的所有保留
      if (exclude) {
        for (let i = 0; i < this.keepIds.length; i++) {
          let keepId = this.keepIds[i];
          if (exclude.indexOf(keepId) > -1) continue;
          unKeepCache(keepId);
          Scroller.remove(keepId);
          // StateProvider.remove(keepId);
          // ProxyProvider.remove(keepId);
          // BAProvider.remove(keepId);
        }
        this.keepIds = [...exclude];
      } else {
        unKeepCache();
        this.keepIds = [];
        Scroller.clear();
        // StateProvider.clear();
        // ProxyProvider.clear();
        // BAProvider.clear();
      }
    } else {
      //移除指定集合v的,但排除exclude以外的保留
      if (type(v) !== "array") v = [v];
      if (exclude) {
        let my = this;
        v.forEach(keepId => {
          if (exclude.indexOf(keepId) > -1) return;
          unKeepCache(keepId);
          Scroller.remove(keepId);
          // StateProvider.remove(keepId);
          // ProxyProvider.remove(keepId);
          // BAProvider.remove(keepId);
          _.remove(my.keepIds, t => {
            return t === keepId;
          });
        });
      } else {
        let my = this;
        v.forEach(keepId => {
          unKeepCache(keepId);
          Scroller.remove(keepId);
          // StateProvider.remove(keepId);
          // ProxyProvider.remove(keepId);
          // BAProvider.remove(keepId);
          _.remove(my.keepIds, t => {
            return t === keepId;
          });
        });
      }
    }
  }

  componentDidMount() {
    this.initialize();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.dispose();
  }

  renderLoading() {
    return <PageLoader />;
  }

  wrapper(content) {
    let { wrapper } = this.props;
    if (wrapper) return wrapper(content);
    return content;
  }

  renderContent() {
    let { children,theme } = this.props;
    let { layout } = this.state;
    return (
      <AppWrapper>
        {
          this.wrapper(
            /* 用react给的lazy和Suspense会闪烁,但是用第三方库，又与keep不兼容，目前只能这样了 */
            <React.Fragment>
              <Suspense fallback={<PageLoader />}>
                <Router>
                  <Switch>
                    {this.renderDefaultRedirect()}
                    {this.renderRoutes()}
                    {this.render404()}
                  </Switch>
                </Router>
              </Suspense>
              <AppSetting layout={layout} theme={theme} />
              {children}
            </React.Fragment>
          )
        }
      </AppWrapper>
    );
  }

  renderError() {
    let { error } = this.state;
    return <ShowError message={error} />
  }

  render() {
    let { loading, error } = this.state;
    if (error) return this.renderError();
    return loading ? this.renderLoading() : this.renderContent();
  }
}

const filterMenus = (function () {

  function filterMenus(menus) {
    menus = menus || [];
    return new Promise((resolve, reject) => {
      try {
        //找出所有需要验证的项
        let items = [];
        fillPreAuthItems(items, menus);
        if (items.length === 0) {
          resolve(menus); //全部菜单都不需要验证
          return;
        }

        authItems(items).then((results) => {
          //标记不合格的项
          results.forEach(({ allow, message }, index) => {
            if (!allow) items[index].notAllow = true;
          });

          //为菜单瘦身
          menus = slimMenus(menus);
          resolve(menus);

        });

      } catch (error) {
        reject(error);
      }
    });
  }

  function fillPreAuthItems(items, menus) {
    menus.forEach((menu) => {
      if (!menu) return;
      if (menu.auth) items.push(menu);
      //继续收集下一级
      if (menu.children) fillPreAuthItems(items, menu.children);
    });
  }

  function authItems(items) {
    return Promise.all(items.map((item) => Principal.verify(item.auth)));
  }

  function slimMenus(menus) {
    let l = [];
    fillSlimMenus(l, menus);
    return l;
  }

  function fillSlimMenus(l, items) {
    items.forEach((item) => {
      if (!item) return;
      if (allow(item)) {
        if (item.children && item.children.length > 0) {
          let cs = [];
          fillSlimMenus(cs, item.children); //将子节点瘦身
          item.children = cs; //重新设置子菜单
        }
        l.push(item);
      }
    });
  }

  function allow(item) { //菜单是否有权限
    if (item.notAllow) return false; //如果自身都没有权限，那么直接返回false
    if (item.children && item.children.length > 0) {
      //如果有子菜单，那么看子菜单是否有一项有权限
      for (let i = 0; i < item.children.length; i++) {
        let c = item.children[i];
        if (!c) continue;
        if (allow(c)) return true;  //如果一项有权限，那么就返回true
      }
      return false;
    }
    return true;  //没有子菜单，且没有标记不允许，那么返回true
  }

  return filterMenus;
})();

export const ShowError = ({ message }) => {
  const dispatch = useDispatch();

  const leave = () => {
    let principal = new Principal({ dispatch });
    signOut({ principal });
  }

  return (
    <div className="d-flex flex-column justify-content-center align-items-start p-3">
      {message?<p className="c-text-s2 m-text-dark75">{message}</p>:null}
      <div className="mt-2 d-flex flex-row justify-content-start align-items-center">
        <Button onClick={() => window.location.reload()}>重新加载</Button>
        {Principal.isLogined() ? <Button color="secondary" onClick={leave} className="ml-2">退出登录</Button> : null}
        {/* <Button onClick={()=> window.location.reload()}>关闭</Button> */}
      </div>
    </div>
  );
}

function History() {
  let items = [];

  this.push = arg => {
    items.push(arg);
  };

  this.pop = () => {
    return items.pop();
  };

  this.current = () => {
    return items[items.length - 1];
  };

  this.items = () => {
    return items;
  };

  this.length = () => {
    return items.length;
  };
}

const mapStateToProps = app => {
  return {}; //仅设置，不接受
};

const App = withRouter(
  connect(mapStateToProps, {
    setSideBar
  })(_App)
);

App.current = () => {
  return _App.current;
};

App.getParamsCode = (params) => {
  let code = JSON.stringify(params);
  return base64.encode(escape(code));//这个库的Base64.encode不支持汉字，所以escape 一下
}

App.getParams = (props) => {
  if(!props) props = 0;
  if (type(props) === "number") {
    let index = props;
    let path = getPath();
    let temp = path.split('/');
    let params = temp[temp.length - 1 + index];
    let code = unescape(base64.decode(params));
    return JSON.try(code);
  }

  {
    let match = props.match;
    if (!match || !match.params) return {};
    let { params } = match.params;
    if (!params) return {};
    let code = unescape(base64.decode(params));
    return JSON.try(code);
  }  
}


App.data = () => {
  return App.current().data();
}

App.dispatch = () => {
  return App.current().dispatch();
};

App.fetchLoading = (flag) => {
  let dispatch = App.dispatch();
  dispatch(fetchLoading(flag));
};

App.fetchSuccess = (message) => {
  let dispatch = App.dispatch();
  dispatch(fetchSuccess(message));
};

App.fetchError = (message) => {
  let dispatch = App.dispatch();
  dispatch(fetchError(message));
};

export default App;

export function go(name, params, onBack) {
  App.current().go(name, params, onBack);
}

export function replace(name, params, onBack) {
  App.current().replace(name, params, onBack);
}

const AppSetting = ({ layout,theme }) => {
  // const { setLayout } = useContext(AppContext);
  const {
    setShowHeader,
    setShowFooter,
    setSidebarType,
    setSidebarWidth,
    setHeaderType
  } = useContext(LayoutContext);

  const {
    setHeaderComponent,
    setHeaderBoxComponent,
    setHeaderToolComponent,
    setHeaderLogo,
    setHeaderDraggable,
    setFooterComponent
  } = useContext(AppContext);

  const { setTheme,setThemeType,theme : defaultTheme } = useContext(AppContext);

  const setAppTheme = (app_theme)=>{

    setTheme(theme => ({
      ...theme,
      ca:defaultTheme.ca_global
    }));

    if(!app_theme) return;
 
    let custom = getTheme(app_theme);
    
    // setThemeType(THEME_TYPES.LIGHT);

    let t = _.cloneDeep(defaultTheme.ca_global);
    _.merge(t,custom);

    setTheme(theme => ({
      ...theme,
      ca:t,
    }));
  }

  let { header = {}, footer = {}, sidebar = {} } = layout;

  useEffect(() => {
    setHeaderType("static");

    setHeaderComponent(header.component);
    setHeaderBoxComponent(header.box);
    setHeaderToolComponent(header.tool);
    setHeaderDraggable(header.draggable);
    if(header?.logo){
      setHeaderLogo(header.logo);
    }
    else{
      setHeaderLogo(null);
    }
    if (header.hidden) {
      //隐藏头部
      setShowHeader(false);
    }
    else {
      setShowHeader(true);
    }

    setFooterComponent(footer.component);
    if (footer.hidden) {
      //隐藏底部
      setShowFooter(false);
    }
    else {
      setShowFooter(true);
    }

    if (sidebar.hidden) {
      //隐藏侧边栏
      setSidebarType("hidden");
      setSidebarWidth(0);
    } else {
      setSidebarType("full");
      setSidebarWidth(SIDEBAR_WIDTH.XS);
    }

    // setLayout(LAYOUT_TYPES.HORIZONTAL_DARK);

    //eslint-disable-next-line react-hooks/exhaustive-deps

    setAppTheme(theme);

  }, [layout,theme]);

  return null;
};

function setRequestConfig({ domain, upload }) {

  RequestConfig.domain = domain;
  if(upload)RequestConfig.uploadUrl = upload + "/upload.htm";

  RequestConfig.init = (p, dispatch) => {
    let auther = Principal.getAuther();
    let auth = auther ? auther.data() : null;
    if (!auth) {
      //如果当前域没有授权信息，那么使用extra域的授权信息，避免切换域的时候，获取不到token */
      auther = Principal.getAuther("extra");
      auth = auther ? auther.data() : null;
    }

    if (auth) {
      p.headers = p.headers || {};

      let token = auth.token;
      if (token) p.headers["c-token"] = token;
      p.headers["c-language"] = "zh-CN"; //目前语言选项就一个，中文
    }
  };

  RequestConfig.before = (p, dispatch) => {
    if(!dispatch) return;
    dispatch(fetchStart());
  };

  RequestConfig.complete = dispatch => {
    if(!dispatch) return;
    dispatch(fetchSuccess());
  };

  RequestConfig.error = (msg, dispatch) => {
    console.error(msg);
    if(!dispatch) return;
    dispatch(fetchError(msg));
  };

  RequestConfig.ioc = {
    //所有的请求，都会走注入，
    error: (msg, p, dispatch) => {
      //令牌过期
      if (msg === "tokenExpired") {
        let principal = new Principal({ dispatch });
        signOut({ principal,referrer:true }); //令牌过期，是可以登录后继续操作当前页的，这一般是由于长时间没有操作导致
        return false; //当返回false，表示阻止后续工作
      }
      if (msg === "authError") {
        if (p.authError) {
          //执行自定义授权错误的处理逻辑
          p.authError();
        } else {
          let principal = new Principal({ dispatch });
          signOut({ principal });
          // App.current.go("signin");
        }
        return false; //当返回false，表示阻止后续工作
      }
    }
  };
}

//在当前域名的退出，登录后自动跳转到当前页
function signOut({ principal,referrer}) {
  principal.signOut({referrer});
}

function getPath() {
  //electron 发布模式 路径全部由hash控制，pathname会取不到路径参数
  if (window.$electronRelease) return window.location.hash;
  return window.location.pathname;
}

// //AppLoader用于当App使用之前，要加载服务端数据的情况
// const _AppLoader = ({load,getApp})=>{
//   const [data,setData] = useState(null);

//   useEffect(()=>{
//     load((r)=>{
//       setData(r);
//     });
//   },[]);

//   return data ? getApp(data) : <PageLoader />;
// }

// export const AppLoader = React.memo(_AppLoader, (prevProps, nextProps) => {
//   return memo(prevProps, nextProps, []);
// });


